import { useEffect, useState } from "react";
import axios from "axios";
import config from "config";

const API_URL = config.TRAFFIC;

const useAreaGeom = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);        
        // const response = await axios.get(`${API_URL}/rpc/area_geom`, {          
          const response = await axios.get(`${API_URL}/id_areas`, {          
          headers: { "Accept-Profile": "traffic_monitoring" },
        });

        // console.log("fetch area_geom", response.data);

        const features = response.data.map((item) => ({
          type: "Feature",
          geometry: item.linestring?.geometry || item.geom, // adjust based on actual structure
          properties: {
            area_id: item.area_id,
            name: item.name,
            name_el: item.name_el,
          },
        }));

        
        const formattedData = {
          type: "FeatureCollection",
          features
        };

        // console.log("useAreaGeom formattedData", formattedData);
        
        setData(formattedData);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading };
};

export default useAreaGeom;
